import { Injectable } from '@angular/core';

import { TeaserBetConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipType } from '../../../core/betslip-type';
import { defaultBetBuilderBetState } from '../../bet-builder/models';
import { defaultComboBetState } from '../../combo-bet/state';
import { defaultEditMyBetState } from '../../edit-bet/state';
import { defaultSingleBetState } from '../../single-bet/state';
import SystemBetStateStorageService from '../../system-bet/services/system-bet-state-storage.service';
import { defaultSystemBetState } from '../../system-bet/state';
import TeaserBetStateStorageService from '../../teaser-bet/services/teaser-bet-state-storage.service';
import { defaultTeaserBetState } from '../../teaser-bet/state';
import { populateOrder } from '../../utils/bet-type.utils';
import { defaultBaseTypeState } from '../base/state';
import { IBetslipTypeSavedState, IBetslipTypeState } from '../state';

@Injectable()
export default class BetslipTypesStateStorageService {
    constructor(
        private systemBetStateStorage: SystemBetStateStorageService,
        private teaserBetConfig: TeaserBetConfig,
        private teaserBetStateStorage: TeaserBetStateStorageService,
    ) {}

    toSavedState(state: IBetslipTypeState): IBetslipTypeSavedState {
        const { editBet, ...rest } = state;

        return {
            ...rest,
            systemBet: this.systemBetStateStorage.toSavedState(state.systemBet),
        };
    }

    fromSavedState(state: IBetslipTypeSavedState | undefined): IBetslipTypeState {
        if (!state) {
            return {
                base: defaultBaseTypeState,
                singleBet: defaultSingleBetState,
                comboBet: defaultComboBetState,
                systemBet: defaultSystemBetState,
                teaserBet: defaultTeaserBetState,
                editBet: defaultEditMyBetState,
                betBuilder: defaultBetBuilderBetState,
            };
        }

        return {
            ...state,
            singleBet: {
                ...state.singleBet,
                picks: populateOrder(state.singleBet.picks),
            },
            base:
                (!this.teaserBetConfig.isEnabled && state.base.currentSelectedType === BetslipType.Teaser) ||
                state.base.currentSelectedType === BetslipType.EditBet
                    ? defaultBaseTypeState
                    : state.base,
            systemBet: this.systemBetStateStorage.fromSavedState(state.systemBet),
            teaserBet: this.teaserBetStateStorage.fromSavedState(state.teaserBet),
            editBet: defaultEditMyBetState,
        };
    }
}
